import { persistTrackingData } from '../util';
import { initDataLayer } from '../util/initDataLayer';
import { isBrowser } from '../util/isBrowser';
export function pushRemoveFromShortlist(data) {
    var _a;
    if (!isBrowser())
        return;
    initDataLayer();
    const message = {
        event: 'removeFromWishlist',
        wishlist: {
            lastRemoved: (_a = data.removeHotelFromShortlist) === null || _a === void 0 ? void 0 : _a.estabId,
        },
    };
    window.dataLayer.push(message);
    persistTrackingData(message);
}
